export default __webpack_public_path__ + "static/media/clock.91393d2f.svg";